import * as FilePond from "filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
// Client-side downscale + recompress before upload (the car Entry/Exit and
// worker-dashboard camera photos). The transform runs in a Web Worker, so the
// 12MP decode happens OFF the main thread — the memory-safe path for low-RAM
// Android devices. exif-orientation feeds the real EXIF rotation to the
// transform so a re-encoded photo is never stored sideways.
//
// All three are GATED OFF by default (allowImageResize / allowImageTransform =
// false in each manager's globalConfig) and switched on per-instance only for
// the camera flows, so every other upload in the app is left untouched.
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";

FilePond.registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize,
    FilePondPluginImageExifOrientation,
    FilePondPluginImageResize,
    FilePondPluginImageTransform
);

export { FilePond };
